module.exports = __webpack_public_path__ + "img/barchart-geschlecht.9931c90d.png";